export default __webpack_public_path__ + "static/media/empty.ebf47185.png";